import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@clds/button-old';
import { ModalNext, ModalNextProps } from '@clds/modal-old';
import { messages } from '../../i18n';
import { NarrowModalLayout } from './layout/NarrowModalLayout';
import { DisplayAssetsFormFields } from './DisplayAssetsFormFields';
import { DisplayAssetsFormData } from '../../types';

export interface DisplayAssetsModalProps extends ModalNextProps {
  formData: DisplayAssetsFormData;
  onChange: (data: DisplayAssetsFormData) => void;
  onSubmit: () => void;
  onCancel: () => void;
}

export const DisplayAssetModal: FC<DisplayAssetsModalProps> = ({ formData, onSubmit, onCancel, onChange, ...rest }) => {
  const isFormValid = formData.details.trim() !== '';

  return (
    <ModalNext {...rest}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
      >
        <NarrowModalLayout
          accent
          closeIcon
          header={<FormattedMessage {...messages.loginAsDisplayAssetsModalHeader} />}
          footer={
            <>
              <Button variant="secondary" onClick={onCancel} data-test-specifier="cancel-button">
                <FormattedMessage {...messages.loginAsDisplayAssetsModalCancelButtonLabel} />
              </Button>
              <Button type="submit" isDisabled={!isFormValid} variant="primary" data-test-specifier="submit-button">
                <FormattedMessage {...messages.loginAsDisplayAssetsModalSubmitButtonLabel} />
              </Button>
            </>
          }
        >
          <DisplayAssetsFormFields formData={formData} onChange={onChange} />
        </NarrowModalLayout>
      </form>
    </ModalNext>
  );
};
